<script setup lang="ts">
import { ref, computed, onMounted, onBeforeUnmount } from 'vue';
import { eventBus } from '@tools/event-bus';
import { OFFER_EVENT } from '@organisms/offer/constants';
import { Slider } from '@enums/event.ts';
import OfferProposal from './Sliders/OfferProposal.vue';

interface AddProposalPayload {
  hashIds: string[],
  teamSize: number | null,
  teamSizeList: number[],
}

type Payload = AddProposalPayload;

const currentOpenedComponent = ref<Slider | null>(null);
const payload = ref<Payload | null>(null);

const isOfferProposal = computed<boolean>(() => currentOpenedComponent.value === Slider.CREATE_PROPOSAL);

const close = (): void => {
  currentOpenedComponent.value = null;
};

const sliderShowListener = (event: CustomEvent): void => {
  const { sliderType, sliderPayload } = event.detail as { sliderType: Slider, sliderPayload: Payload };
  currentOpenedComponent.value = sliderType;

  if (!currentOpenedComponent.value) {
    return;
  }

  payload.value = sliderPayload;
};

onMounted(() => {
  eventBus.addEventListener(OFFER_EVENT.SLIDER_SHOW, sliderShowListener);
});

onBeforeUnmount(() => {
  eventBus.removeEventListener(OFFER_EVENT.SLIDER_SHOW, sliderShowListener);
});
</script>

<template>
  <div
    v-if="currentOpenedComponent && payload"
    class="sliders"
  >
    <OfferProposal
      v-if="isOfferProposal"
      :is-opened="isOfferProposal"
      :payload="payload"
      @close="close"
    />
  </div>
</template>
